import { render, staticRenderFns } from "./TestReports.vue?vue&type=template&id=9dad09d2&scoped=true&"
import script from "./TestReports.vue?vue&type=script&lang=js&"
export * from "./TestReports.vue?vue&type=script&lang=js&"
import style0 from "./TestReports.vue?vue&type=style&index=0&id=9dad09d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dad09d2",
  null
  
)

export default component.exports